export interface CertificadoEtica {
  id: number
  matriculate_id: number
  state_id: number
  target: string
  reason: string
  validity: number
  date: string
  rejection_text: any
  external: number
  created_at: string
  resolved_at: string
  path: string
  url: string
}

export interface CertificadoEticaList {
  count: number;
  rows: CertificadoEtica[];
}

export function getEstadoLabel(id: number | undefined) {
  switch (id) {
    case 1: return 'Solicitado';
    case 2: return 'Aprobado';
    case 3: return 'Rechazado';
    default: return 'Desconocido';
  }
}
